export default __webpack_public_path__ + "static/media/hero-pump-testing.57082e3c.jpg";